import { h } from 'preact';

import LazyRpmGoodExperience from '../../components/rpmGoodUxCard/lazyRpmGoodUxCard.jsx';

export default function LazyRpmDataSource(_props) {
  return (
    <>
      <LazyRpmGoodExperience />
      <LazyRpmGoodExperience />
      <LazyRpmGoodExperience />
      <LazyRpmGoodExperience />
    </>
  );
}
